import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-font-awesome5-pro-page-configurator',
	templateUrl:'./FontAwesome5ProPageConfiguratorPluginCompPage.html',
	styles: [],
	styleUrls:['./FontAwesome5ProPageConfiguratorPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class FontAwesome5ProPageConfiguratorPluginCompPage
{
	mdContent_920 = `\`\`\`java
import com.jwebmp.plugins.fontawesome5pro.FontAwesome5ProPageConfigurator;
\`\`\``;
	mdContent_921 = `\`\`\`java
// In your startup/configuration:
FontAwesome5ProPageConfigurator.setKitCode("cf4534f35c");
// All Pro icons are now loaded from the cloud — no npm packages needed
\`\`\``;
	mdContent_922 = `\`\`\`java
// Enable just the families you need
FontAwesome5ProPageConfigurator.enableFamily(IconFamily.Duotone);
FontAwesome5ProPageConfigurator.enableFamily(IconFamily.Sharp);
FontAwesome5ProPageConfigurator.enableFamily(IconFamily.Jelly);
\`\`\``;
	mdContent_923 = `\`\`\`java
FontAwesome5ProPageConfigurator.setEnableAllProVariants(true);
\`\`\``;
}
